import { useCallback, useEffect, useState } from "react"

export default function useMobile (width = 768){
    const [mobile,setMobile] = useState(false)

    const isMobile  = useCallback(() => {
        setMobile((window.innerWidth < width))
    },[width])

    useEffect(() =>{
        isMobile()
        window.addEventListener('resize',isMobile)
        return () => window.removeEventListener('resize',isMobile)
    },[isMobile])

    return mobile

}   